import React from "react";
import { useTranslation } from "react-i18next";
import useSkin from "src/hooks/useSkin";
import { BadgeContainer, Dot } from "./EngagementBadge.styles";

type EngagementBadgeProps = {
  score: number;
  size?: "sm" | "md";
};

const getEngagementLevel = (score: number): { color: string; labelKey: string } => {
  if (score >= 70) return { color: "#22c55e", labelKey: "engagement_level_high" };
  if (score >= 40) return { color: "#f59e0b", labelKey: "engagement_level_medium" };
  return { color: "#ef4444", labelKey: "engagement_level_low" };
};

const EngagementBadge = ({ score, size = "sm" }: EngagementBadgeProps) => {
  const [t] = useTranslation();
  const { isGriffle } = useSkin();
  const { color, labelKey } = getEngagementLevel(score);

  return (
    <BadgeContainer $color={color} $size={size} $isGriffle={isGriffle}>
      <Dot $color={color} />
      {t(labelKey)}
    </BadgeContainer>
  );
};

export default EngagementBadge;
